module.exports = __webpack_public_path__ + "images/emoji/fountain.eba44adaa034a442f89d.png";